var map = {
	"./A-logo.png": 6201,
	"./Arindam_Resume.pdf": 6936,
	"./about-dp.jpg": 5433,
	"./ari_dp2.jpeg": 3914,
	"./ari_dp_int.jpg": 5785,
	"./bot.png": 91,
	"./c++.png": 3549,
	"./c.png": 8122,
	"./coding.png": 7149,
	"./contact.png": 8091,
	"./contact2.png": 4655,
	"./contact3.png": 7505,
	"./contact4.png": 6269,
	"./copyright.png": 8513,
	"./dp-8.png": 97,
	"./education.png": 5337,
	"./email.png": 4089,
	"./ex.png": 6348,
	"./firebase.png": 7770,
	"./footer2.png": 8524,
	"./footer3.png": 234,
	"./home_dp.jpeg": 4525,
	"./html-css.png": 8269,
	"./java.png": 1770,
	"./js.jpg": 9209,
	"./js.png": 9539,
	"./logo-bg.png": 4740,
	"./logo.jpg": 5051,
	"./logo2-removebg-preview.png": 346,
	"./mongodb.png": 1213,
	"./nextjs.png": 8948,
	"./nodejs.png": 2462,
	"./paint-palette.png": 2272,
	"./plus.png": 5853,
	"./project0.png": 7564,
	"./project1.png": 8949,
	"./project10.png": 4111,
	"./project11.png": 1731,
	"./project12.png": 7786,
	"./project13.png": 2670,
	"./project2.png": 9852,
	"./project3.png": 618,
	"./project4.png": 9140,
	"./project5.png": 8834,
	"./project6.png": 351,
	"./project7.png": 4167,
	"./project8.png": 3331,
	"./project9.png": 8192,
	"./python.png": 8132,
	"./reactjs.jpg": 8898,
	"./resume.pdf": 3480,
	"./trophy.png": 7446,
	"./wavy-dark.png": 6261,
	"./wavy.png": 5256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6235;